import {
  MEDICINE_LIST_REQUEST,
  MEDICINE_LIST_SUCCESS,
  MEDICINE_LIST_FAIL,
} from "../../constants/patientConstants/medicineConstants.js";

const initialState = { medicines: [] };

export const medicineReducer = (state = initialState, action) => {
  switch (action.type) {
    case MEDICINE_LIST_REQUEST:
      return { ...state, loading: true };
    case MEDICINE_LIST_SUCCESS:
      return { loading: false, medicines: action.payload };
    case MEDICINE_LIST_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};
